'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackBeforeUnload = exports.track = undefined;

var _usageTracker = require('usage-tracker');

var _isApiBlackListed = require('ui-addon-upgrades/_core/common/navigation/isApiBlackListed');

var _events = require('ui-addon-upgrades/events.yaml');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AMPLITUDE_APP_NAME = 'upgrades';

var _tracker = (0, _usageTracker.createTracker)({
  events: _events2.default,
  properties: {
    namespace: AMPLITUDE_APP_NAME
  }
});

var _beaconTracker = _tracker.clone({ isBeforeUnload: true });

var _transformEventProperties = function _transformEventProperties(eventProperties) {
  if (!eventProperties) return {};
  var notAssigned = 'Not assigned';
  var repInfo = eventProperties.repInfo;
  delete eventProperties.repInfo;
  eventProperties.repName = repInfo ? repInfo.name || notAssigned : notAssigned;
  return eventProperties;
};

var track = exports.track = function track(eventKey, eventProperties) {
  if ((0, _isApiBlackListed.isApiBlackListed)()) {
    return;
  }

  eventProperties = _transformEventProperties(eventProperties);
  _tracker.track(eventKey, eventProperties);
};

// Uses beacon to ensure events get sent if tracking just before the page unloads
// https://product.hubteam.com/docs/usage-tracking-manual/docs/javascript/external-link-click-tracking.html
var trackBeforeUnload = exports.trackBeforeUnload = function trackBeforeUnload(eventKey, eventProperties) {
  if ((0, _isApiBlackListed.isApiBlackListed)()) {
    return;
  }

  eventProperties = _transformEventProperties(eventProperties);
  _beaconTracker.track(eventKey, eventProperties);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/eventTracking/tracker.js
// module id = 20
// module chunks = 3 4 5